var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step progressbar row mb-4" }, [
    _c("div", { staticClass: "col-lg-1" }),
    _c("div", { staticClass: "col-lg-10" }, [
      _c("div", { staticClass: "d-flex justify-content-between mt-5" }, [
        _c(
          "div",
          {
            staticClass: "step-indicator-outer",
            class: _vm.getProgressbar.step0,
          },
          [
            _c("div", { staticClass: "pt-5 step-indicator" }, [
              _c("p", { staticClass: "bodytext m-0" }, [
                _c("b", [
                  _c("span", { staticClass: "number" }, [_vm._v("1.")]),
                  _vm._v(" " + _vm._s(_vm.trans("sample_order_step1"))),
                ]),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "step-indicator-outer",
            class: _vm.getProgressbar.step1,
          },
          [
            _c("div", { staticClass: "pt-5 step-indicator" }, [
              _c("p", { staticClass: "bodytext m-0" }, [
                _c("b", [
                  _c("span", { staticClass: "number" }, [_vm._v("2.")]),
                  _vm._v(" " + _vm._s(_vm.trans("sample_order_step2"))),
                ]),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "step-indicator-outer",
            class: _vm.getProgressbar.step2,
          },
          [
            _c("div", { staticClass: "pt-5 step-indicator" }, [
              _c("p", { staticClass: "bodytext m-0" }, [
                _c("b", [
                  _c("span", { staticClass: "number" }, [_vm._v("3.")]),
                  _vm._v(" " + _vm._s(_vm.trans("sample_order_step3"))),
                ]),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "step-indicator-outer last",
            class: _vm.getProgressbar.step3,
          },
          [
            _c("div", { staticClass: "pt-5 step-indicator" }, [
              _c("p", { staticClass: "bodytext m-0" }, [
                _c("b", [
                  _c("span", { staticClass: "number" }, [_vm._v("4.")]),
                  _vm._v(" " + _vm._s(_vm.trans("sample_order_step4"))),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
    _c("div", { staticClass: "col-lg-1" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }